import { requestWithToken } from '../utilities/request';

const path = '/api/private/fields';

// api :GET, '/api/private/fields/:field_id/field_item_lists/list', '現場作業エリア情報取得API'
const list = (fieldId, param, isQuiet = false) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_item_lists/list`),
    params: param,
    isQuiet,
  });
};

const create = (fieldId, param) => {
  param.display_flag = 1;
  param.order_number = 0;
  return requestWithToken({
    method: 'POST',
    url: path.concat(`/${fieldId}/field_item_lists`),
    params: param,
  });
};

const update = (fieldId, id, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${fieldId}/field_item_lists/${id}`),
    params: param,
  });
};

const updateOrder = (field_id, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${field_id}/field_item_lists/update_order`),
    data: param,
  });
};

const del = (fieldId, id) => {
  return requestWithToken({
    method: 'DELETE',
    url: path.concat(`/${fieldId}/field_item_lists/${id}`),
  });
};

/**
 * 現場作業エリア情報取得
 * @param fieldId {int}
 * @param id {int}
 */
const show = (fieldId, id) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_item_lists/${id}`),
  });
};

export const FieldItemService = {
  list,
  create,
  update,
  updateOrder,
  del,
  show,
};

export default FieldItemService;



// WEBPACK FOOTER //
// ./src/services/FieldItems.js